<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.cadastro.logradouroTipo"
        ref="RkmDataTable"
    />
</template>

<script>
export default {
    computed: {
        fields() {
            return [
                {key: 'tipo_nome', label: 'Nome', name: 'cadastro_logradouro_tipo.nome', searchable: true, sortable: true},
            ]
        },
    },
    inject: ['repositories'],
}
</script>